<template>
  <div class="home">
    <v-btn @click="login">로그인</v-btn>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },

  methods: {
    link: function (path) {
      this.$router.push(path)
    },

    login: function () {
      this.$router.replace('Login')
    }
  }
}
</script>
